import React, { FunctionComponent, useContext } from 'react';
import styles from './contact-employee.module.scss';
import { IButtonProps } from '../button/button';
import { IEmployeeBoxProps } from '../employee-box/employee-box';
import { Button } from '../button/button';
import { AppDeviceSize } from '../../enums/app-device-size';
import { AppStore } from '../../store/app.context';

export interface IContactEmployeeProps {
  employee: IEmployeeBoxProps | null;
  title: string;
  subtitle: string;
  button: IButtonProps | null;
}

export const ContactEmployee: FunctionComponent<IContactEmployeeProps> = ({
  employee,
  title,
  subtitle,
  button
}) => {
  const { state } = useContext(AppStore);
  const { showActiveDevice } = state;

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
      <div className={styles.employee}>
        <div className={styles.imageWrapper}>
          <img
            className={styles.image}
            src={employee?.photoUrl || ''}
            alt="employee"
          />
        </div>
        <div className={styles.employeeInfo}>
          <div className={styles.employeeName}>
            <strong>
              {employee?.firstName} {employee?.lastName}
            </strong>
          </div>
          {employee?.position}
          {button && showActiveDevice > AppDeviceSize.MOBILE && (
            <div className={styles.button}>
              <Button {...button} />
            </div>
          )}
        </div>
      </div>
      {button && showActiveDevice <= AppDeviceSize.MOBILE && (
        <div className={styles.button}>
          <Button {...button} />
        </div>
      )}
    </div>
  );
};
